"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var storageKeys = {
  USER: 'lettucegrow-user-012022',
  CART: 'lettucegrow-cart-012022',
  AUTOFILL_OPT_IN: 'lettucegrow-autofill-optin-032323',
  OPTIMISTIC_AUTOFILL_OPT_IN: 'lettucegrow-optimistic-autofill-optin-032323'
};
exports.default = storageKeys;